/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { AnalyticsMatchRecord } from '../../domain/interfaces/tournament-analytics';

interface MatchRecordCardProps {
  title: string;
  icon: React.ReactNode;
  record: AnalyticsMatchRecord | null;
  highlightLabel: string;
}

const Card = styled.div`
  background: #1f2937;
  border: 1px solid #374151;
  border-left: 4px solid #6ee7b7;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d1d5db;
  font-size: 14px;
  font-weight: 600;

  svg {
    color: #6ee7b7;
    flex-shrink: 0;
  }
`;

const EmptyState = styled.div`
  color: #6b7280;
  font-size: 14px;
  text-align: center;
  padding: 12px 0;
`;

const ScoreRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const TeamName = styled.span`
  color: #f9fafb;
  font-size: 15px;
  font-weight: 600;
  flex: 1;
  text-align: center;
`;

const Score = styled.span`
  color: #6ee7b7;
  font-size: 22px;
  font-weight: 700;
  white-space: nowrap;
`;

const Footer = styled.div`
  color: #9ca3af;
  font-size: 12px;
  text-align: center;
`;

const MatchRecordCard = React.memo(({ title, icon, record, highlightLabel }: MatchRecordCardProps) => {
  return (
    <Card>
      <TitleRow>
        {icon}
        <span>{title}</span>
      </TitleRow>
      {record === null ? (
        <EmptyState>Нет данных за выбранный период</EmptyState>
      ) : (
        <>
          <ScoreRow>
            <TeamName>{record.teamAName}</TeamName>
            <Score>
              {record.teamAScore} : {record.teamBScore}
            </Score>
            <TeamName>{record.teamBName}</TeamName>
          </ScoreRow>
          <Footer>
            {record.championshipName} · {format(new Date(record.matchDate), 'd MMM yyyy', { locale: ru })} · {highlightLabel}: {record.highlightValue}
          </Footer>
        </>
      )}
    </Card>
  );
});

export default MatchRecordCard;
